import {
    BasisActions,
    BasisState,
    CheckoutState,
    PackageActions,
    PackageState,
} from '@raskrask-dk/bookingflow-state-machine'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { useBFSMValue } from '../../../services/hooks/useBFSMValues'
import PackageInformationTemplate from './template'
import { Package } from '@raskrask-dk/raskrask-utils'
import { useBFSM } from 'contexts/bfsmContext'

const PackageInformationPage = (): ReactElement => {
    const { t } = useTranslation()
    const [BFSM] = useBFSM()
    const [basisType] = useBFSMValue<
        BasisState,
        BasisActions.SetBasisType,
        'basisType'
    >('basisType')
    const [goal] = useBFSMValue('goal')
    const [partner] = useBFSMValue<
        PackageState,
        PackageActions.SetPartner,
        'partner'
    >('partner')
    const [product] = useBFSMValue('product')
    const { customer } = BFSM.getData<CheckoutState>()
    const label = t(`klippeCard_Label${goal.id}`)
    const packageService = `${(product as Package).multiplier}x${
        (product as Package).service.duration.toMillis() / 60 / 1000
    } min`

    return (
        <PackageInformationTemplate
            basisType={basisType!}
            packageName={label}
            partnerName={partner!.alias}
            packageService={packageService}
            customer={customer}
        />
    )
}

export default PackageInformationPage
